const translations = {
  changeLanguage: 'Idioma: ',
  welcomeName: '¡Bienvenido {0}!',
  signIn: 'Ingresar',
  signInGoogle: 'Iniciar sesión con Google',
  signInFacebook: 'Iniciar sesión con Facebook',
  email: 'Correo electrónico',
  emailRequired: 'Correo electrónico requerido',
  enterYourEmail: 'Ingresa tu correo electrónico',
  invalidEmail: 'Correo electrónico inválido',
  password: 'Contraseña',
  passwordRequired: 'Contraseña requerida',
  enterYourPassword: 'Ingresa tu contraseña',
  forgotPassword: '¿Olvidaste tu contraseña?',
  createAccount: 'Crear una cuenta',
  creating: "Creando...",
  creatingYourAccount: 'Creando tu cuenta',
  verifyAccount: 'Crear una cuenta',
  passwordReset: 'Restablecer la contraseña',
  setNewPassword: 'Establecer nueva contraseña',
  createNewPassword: 'Crear nueva contraseña',
  age: 'edad',
  welcome: 'Bienvenido',
  back: 'Atras',
  or: 'O',
  incorrectLogin: 'Nombre de usuario o contraseña incorrectos.',
  name: 'Nombre',
  username: 'Nombre de usuario',
  usernameRequired: 'Nombre de usuario requerido',
  enterYourUsername: 'Ingresa tu nombre de usuario',
  confirmPassword: 'Confirmar contraseña',
  passwordSettings: 'Su contraseña debe tener lo siguiente:',
  oneUppercase: 'Al menos una letra mayúscula',
  oneLowercase: 'Al menos una letra mayúscula',
  oneDigit: 'Al menos un dígito',
  oneSpecialCharacter: 'Al menos un carácter especial',
  more8Characters: 'Debe tener más de 8 caracteres',
  less16Characters: 'Debe tener menos de 16 caracteres',
  fillAllFields: 'Por favor complete todos los campos.',
  validEmail: 'Por favor ingrese un correo electrónico válido.',
  validEmailAccount: 'Ingrese un correo electrónico válido o cree una cuenta',
  confirmEmail: 'Confirma tu correo electrónico',
  here: 'aquí',
  passwordNotMatch: 'Las contraseñas no coinciden',
  signUp: 'Registrarse',
  enterEmailAddress:
    'Ingrese su dirección de correo electrónico y le enviaremos un código para ayudar a restablecer su contraseña.',
  sendResetCode: 'Enviar código de reinicio',
  enterResetCode: 'Ingrese el código de reinicio',
  checkEmail: 'Por favor revise su correo electrónico',
  forResetCodeAndCreatePassword:
    'para restablecer el código y crear una nueva contraseña.',
  enterCorrectResetCode: 'Por favor, ingrese el código de reinicio correcto.',
  reEnterPassword: 'Vuelva a ingresar la contraseña',
  updatePassword: 'Actualizar contraseña',
  updating: "Actualizando...",
  emailAlreadyExists:
    'Ya existe una cuenta con el correo electrónico indicado.',
  checkEmailForConfirmationCode:
    'Revise su correo electrónico para obtener un código de confirmación. Esto puede demorar varios minutos.',
  invalidVerificationCode:
    'Código de verificación proporcionado no válido, inténtalo de nuevo.',
  newVerificationCodeSentSuccesfully:
    'Nuevo código de verificación enviado con éxito.',
  enterConfirmationCode: 'Ingresa tu código de confirmación.',
  didNotReceiveCode: '¿No recibiste tu código de verificación?',
  resendCode: 'Reenviar código',
  replaceTemporaryPassword:
    'Reemplace su contraseña temporal con una nueva contraseña para',
  setPassword: 'Establecer contraseña',
  alertNewActionTitle: 'Nuevas acciones que necesitan validación',
  alertNewActionText: '¡Tienes {0} acciones para validar!',
  startValidating: 'Comenzar a validar',
  alertActionsPendingTitle: '{0} acciones pendientes de validación',
  alertActionsPendingText:
    'El impacto de sus acciones pendientes es {0} de CO2 ahorrado',
  recentProgress: 'Progreso reciente',
  logANewAction: 'Registrar una nueva acción',
  co2SavedWeek: 'CO2 ahorrado esta semana',
  collectiveImpact: 'Impacto colectivo',
  myGroups: 'Mis Grupos',
  myActions: 'Mis Acciones',
  createNewGroup: 'Crear nuevo grupo',
  globalGroups: 'Grupos globales',
  globalUsers: 'Usuarios globales',
  totalCO2Saved: 'CO2 total ahorrado',
  weeklyCO2Saved: 'CO2 ahorrado semanalmente',
  leaderboardDisplaying:
    'Tabla de clasificación que muestra {tab} clasificada por ',
  rank: 'Rango',
  totalCO2: 'CO2 Total',
  totalPoints: 'Puntos Totales',
  membersCount: 'Los miembros cuentan',
  weeklyCO2: 'CO2 Semanal',
  weeklyPoints: 'Puntos Semanales',
  totalCO2Colon: 'CO2 Total:',
  totalPointsColon: 'Puntos Totales:',
  weeklyCO2Colon: 'CO2 Semanal:',
  weeklyPointsColon: 'Puntos Semanales:',
  leaderboards: 'Tablas de clasificación',
  noMyGroups:
    'No hay grupos para mostrar. ¡Crea o únete a un grupo para comenzar!',
  viewGroupStats: 'Ver estadísticas del grupo',
  myContributions: 'Mis contribuciones',
  myContribution: 'Mi Contribución',
  allOtherMembers: 'Todos los demás miembros',
  joinGroup: 'Unirse al grupo',
  read: 'Leer',
  more: 'Más',
  less: 'Menos',
  membersColon: 'Miembros:',
  public: 'Público',
  private: 'Privado',
  leaveGroup: 'Abandonar grupo',
  currentPlace: 'Lugar actual',
  labelRowsPerPage: 'Filas por página:',
  of: 'de',
  groupInfo: 'Información del grupo',
  memberActions: 'Acciones del miembro',
  groupMembers: 'Miembros del grupo',
  addMembers: 'Añadir miembros',
  editGroupInfo: 'Editar información del grupo',
  about: 'Acerca de',
  groupOwners: 'Propietarios del grupo',
  view: 'Ver',
  noActions: 'Actualmente no hay acciones que mostrar.',
  co2SavedColon: 'CO2 ahorrado:',
  totalPointsEarnedColon: 'Puntos totales ganados:',
  unapprove: 'Desaprobar',
  promoteUserToOwner: 'Promover usuario a propietario del grupo',
  demoteUserToMember: 'Degradar usuario a miembro del grupo',
  removeUserFromGroup: 'Eliminar usuario del grupo',
  roleColon: 'Rol:',
  yourRoleColon: 'Tu rol:',
  viewUserProfile: 'Ver perfil de usuario',
  success: '¡Éxito!',
  warning: 'Advertencia!',
  successUserNowOwner: '{0} ahora es propietario del grupo',
  successUserNowMember: '{0} ahora es miembro del grupo',
  successUserNowRemoved: '{0} ha sido eliminado del grupo',
  demotionErrorTitle: 'Error de degradación',
  demotionErrorText: 'Los grupos deben tener al menos 1 propietario del grupo',
  existingUsersTitle: "Para Usuarios Existentes",
  educatorsTitle: "Para Educadores",
  createStudentAccountButton: "Crear Cuenta de Estudiante",
  addMembersDescription:
    'Agrega usuarios a este grupo enviándoles el enlace de tu grupo',
  addMembersDescriptionPassword:
    'Agrega usuarios a este grupo enviándoles el enlace y la contraseña de tu grupo',
  groupLinkLabel: 'Tu enlace de grupo es:',
  groupPasswordLabel: 'Tu contraseña de grupo es:',
  linkCopied: '¡Enlace copiado!',
  passwordCopied: '¡Contraseña copiada!',
  createStudentAccount: {
    title: 'Crear Cuenta de Estudiante',
    successTitle: '¡Cuenta Creada Exitosamente!',
    shareCredentials: 'Por favor comparta estas credenciales con el estudiante:',
    emailHelperText: 'Esto se utilizará como correo electrónico y nombre de usuario',
    passwordHelperText: 'Siga todos los requisitos a continuación.',
    partialSuccessWarning: 'Cuenta de estudiante creada pero hubo un error al configurar el perfil. Por favor comparta el enlace del grupo y pídale que se una al grupo',
    usernameExists: 'Este nombre de usuario ya está en uso. Por favor elija uno diferente.',
    invalidPassword: 'La contraseña no cumple con los requisitos. Por favor verifique los requisitos de contraseña a continuación.',
    invalidEmail: 'Por favor ingrese una dirección de correo electrónico válida.',
    tooManyAttempts: 'Demasiados intentos. Por favor espere un momento antes de intentar nuevamente.',
    noPermission: 'No tiene permiso para crear cuentas de usuario.',
    userPoolError: 'Grupo de usuarios no encontrado. Por favor contacte a soporte.',
    unexpectedError: 'Ocurrió un error inesperado. Por favor intente nuevamente más tarde.',
    requirePasswordChange: '¿Requerir que el estudiante configure su propia contraseña cuando inicie sesión?',
  },
  editGroupEmptyError: 'El nombre del grupo no puede estar vacío',
  editGroupTakenError: 'El nombre del grupo ya está en uso',
  editGroupPasswordError: 'La contraseña no puede estar vacía',
  groupUploadIcon: 'Cargar icono del grupo',
  groupNameEmptyError: 'Este campo debe ser completado',
  groupNameTakenError: 'Ya existe un grupo con el nombre ingresado',
  description: 'Descripción',
  groupPrivacy: 'Privacidad del grupo',
  groupPasswordEmptyError: 'Los grupos privados deben tener una contraseña',
  deleteGroup: 'Eliminar grupo',
  saveGroupInfo: 'Guardar información del grupo',
  join: 'Unirse',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  leave: 'Salir',
  groupUpdatedMsg: 'El grupo ha sido actualizado',
  groupDeletedMsg: '¡{0} ha sido eliminado!',
  homepageRedirectMsg: 'Serás redirigido a la página principal',
  deleteGroupPrompt: 'Eliminar {0}',
  deletePrompAlert: 'Esto es irreversible',
  logout: 'Cerrar sesión',
  leaveGroupLastMemberWarning:
    'Este grupo se eliminará ya que no habrá más miembros en el grupo.',
  promoteOtherUserBeforeLeavingGroup:
    'Debes promover a otro usuario a propietario del grupo antes de dejar el grupo.',
  removeGroupOwner: 'Eliminar propietario de grupo',
  promoteOtherUserBeforeRemovingUser:
    'Debes promover a otro usuario a propietario del grupo antes de eliminar a este usuario.',
  leftGroup: '¡Has abandonado el grupo!',
  joinGroupAlreadyMember: '¡Ya eres miembro de este grupo!',
  joinGroupTitle: 'Has sido invitado a unirte a {0}',
  successRedirectProfilePage:
    '¡Éxito! Redirigiendo a la página de perfil de {0}',
  joinGroupConfirm: 'Confirma seleccionando Unirse.',
  joinGroupSelectCancel:
    'Seleccione Cancelar para ser redirigido a la página del grupo.',
  joinGroupEnterPassword:
    'Para unirte a este grupo, ingresa la contraseña del grupo y selecciona Unirse.',
  incorrectPassword: 'Contraseña incorrecta',
  logAction: 'Registrar Acción',
  logActionMobile: 'Registrar Acción',
  dashboard: 'Panel',
  home: 'Inicio',
  groups: 'Grupos',
  findGroup: 'Buscar Grupo',
  createGroup: 'Crear Grupo',
  validateActions: 'Validar Acciones',
  adminDashboard: 'Panel de Administrador',
  myAccount: 'Mi Cuenta',
  logActionTitle: 'Registrar Nueva Acción',
  logActionStep1: 'Seleccionar Acción',
  logActionStep2: 'Agregar Acción',
  logActionStep3: 'Buen Trabajo',
  logActionStep4: 'CO2 Ahorrado',
  logActionStep5: 'Pregunta Extra',
  logActionStep6: '¡Compartir en Redes!',
  next: 'Siguiente',
  previous: 'Anterior',
  chooseDate: 'Fecha Completada',
  mustBeNumber: 'El valor debe ser un número decimal mayor que 0',
  imageValidationText:
    'Por favor sube una imagen relacionada con el elemento de tu acción para su verificación',
  imageValidationDimensions: 'Dimensiones mínimas 100x100 px',
  imageValidationError: 'Esto no es un archivo de imagen',
  imageValidationSelected: '¡Imagen Seleccionada!',
  imageValidationDrop: 'Arrastra tu imagen aquí, o',
  browse: 'Navegar',
  selectFile: "Seleccionar archivo",
  showUsTheProof: "¡Muéstranos la prueba!",
  linkHere: 'Navegar',
  uploadImageInfo:
    'Manténlo profesional. Una IA puede revisar tu foto, pero también puede hacerlo un humano.',
  uploadImage: 'Subir Imagen',
  topTips: 'Consejos Principales',
  uploadPhoto: '¡Sube una foto!',
  skip: 'Saltar',
  actionFactResponse: '¡Gracias por enviar una acción!',
  actionFactAllFacts: 'Has visto todos los datos para esta acción',
  bonusQuizChoicesLabel: 'Opciones de respuesta',
  bonusQuizSubmit: 'Enviar Quiz',
  bonusQuizSkip: 'Saltar Quiz',
  bonusQuiz: 'Quiz Extra',
  correct: 'Correcto!',
  incorrect: 'Incorrecto!',
  finish: 'Finalizar',
  tryAgain: 'Intentar de nuevo',
  co2SavedScreenState: 'Tu acción está siendo actualmente',
  submitted: 'enviada',
  validated: 'validada',
  co2SavedScreenSkip:
    'Presiona saltar para ver los resultados de validación en otro momento',
  thankYou: '¡Gracias!',
  co2SavedScreenValidated: 'Tu acción ha sido validada',
  co2SavedScreenSaved: '¡Buen trabajo! ¡Has ahorrado {0} g de CO2!',
  co2SavedScreenApproval:
    'Tu acción está pendiente de aprobación del administrador',
  co2SavedScreenImpact: 'El impacto de tu acción es {0} g de CO2 ahorrado',
  co2SavedScreenAnother: 'Agregar Otra Acción',
  takeBonusQuiz: '¡Puedes ganar aún más puntos haciendo el quiz extra!',
  createGroupTitle: 'Crear nuevo grupo',
  uploadGroupIcon: 'Subir ícono del grupo',
  groupName: 'Nombre del grupo',
  groupDescription: 'Descripción del grupo',
  redirectGroupPage: 'Serás redirigido a la página del grupo',
  nameC: 'Nombre:',
  emailC: 'Correo electrónico:',
  editInfo: 'Editar información',
  loggedActions: 'Acciones registradas',
  awaitingValidation: 'Esperando validación',
  notPassValidation: 'No pasó la validación',
  noValidatedActions: 'No hay acciones validadas para mostrar',
  noUnvalidatedActions: 'No hay acciones por validar para mostrar',
  noFailedActions: 'No hay acciones fallidas para mostrar',
  deleteEntry: 'Eliminar entrada',
  deleteEntryConfirmTitle: '¿Eliminar esta entrada?',
  deleteEntryConfirmBody: 'Esta acción se eliminará permanentemente. Esto no se puede deshacer.',
  deletingEntry: 'Eliminando entrada...',
  deleteEntrySuccess: 'Entrada eliminada.',
  deleteEntryFailure: 'No se pudo eliminar esta entrada. Inténtalo de nuevo.',
  editAccountInfoTitle: 'Editar información de la cuenta',
  uploadProfilePhoto: 'Subir foto de perfil',
  requiredFieldsMessage: 'Por favor, completa todos los campos requeridos',
  saveNameEmailPhoto: 'Guardar nombre, correo electrónico y foto',
  deleteAccount: 'Eliminar cuenta',
  deleteAccountWarning: '¿Estás seguro de que deseas eliminar tu cuenta? Toda tu información será eliminada y se cerrará tu sesión.',
  deleteAccountProgress: 'Eliminando tu cuenta...',
  deleteGroupsMsg: 'Antes de eliminar tu cuenta, por favor asigna nuevos administradores a los siguientes grupos que posees:',
  changePassword: 'Cambiar contraseña',
  currentPassword: 'Contraseña actual',
  currentPasswordMessage: 'La contraseña actual es incorrecta',
  newPassword: 'Nueva contraseña',
  confirmNewPassword: 'Confirmar nueva contraseña',
  passwordsDontMatch: 'Las contraseñas no coinciden',
  savePassword: 'Guardar contraseña',
  toggleCurrentPassword: 'alternar visibilidad de la contraseña actual',
  toggleNewPassword: 'alternar visibilidad de la nueva contraseña',
  toggleConfirmNewPassword:
    'alternar visibilidad de la confirmación de la nueva contraseña',
  findGroupTitle: 'Buscar grupo',
  findGroupDescription:
    'Ingresa el nombre del grupo para buscar grupos públicos',
  findGroupErrorSearch:
    'Tu búsqueda de "{0}" no coincide con ningún grupo público',
  findGroupTopGroups:
    'Estos son los 5 grupos públicos más populares a los que podrías unirte',
  searchResults: 'Resultados de búsqueda',
  validateActionsUsersWithoutGroupsTab: 'Usuarios sin grupo',
  validateActionsAllUnvalidatedActionsTab: 'Todas las acciones sin validar',
  validateActionsFlaggedImagesTab: 'Imágenes marcadas',
  flaggedImagesEmpty: 'No hay imágenes marcadas para revisar',
  flaggedSendToReview: 'Enviar a revisión',
  flaggedReject: 'Rechazar',
  pendingPhotoCheck: 'Pendiente de verificación de la foto',
  photoUnderReview: 'Foto en revisión',
  searchByC: 'Buscar por:',
  actionName: 'Nombre de la acción',
  search: 'Buscar',
  groupNameSearchEmptySearch:
    'Tu búsqueda de "{0}" no coincide con ningún grupo que posees',
  groupNameSearchNoGroups: 'Actualmente no posees ningún grupo',
  filteringBy: 'Filtrando por:',
  currentFilter: 'Filtro actual',
  changeFilter: 'Cambiar filtro',
  sortingBy: 'Ordenar por',
  changeSortingOrder: 'Cambiar el orden de clasificación',
  groupNameSearchAllFilter: 'Todos mis grupos',
  validateActionsNoActions: 'No hay acciones que necesiten validación',
  actionNameSearchAllFilter: 'Todos los tipos de acciones',
  actionNameSearchEmptySearch:
    'Tu búsqueda de "{0}" no coincide con ningún nombre de tipo de acción',
  actionNameSearchNoActions: 'Actualmente no hay tipos de acciones',
  submittedInC: 'Enviado en:',
  accept: 'Aceptar',
  reject: 'Rechazar',
  actions: 'Acciones',
  clearSearch: 'Borrar búsqueda',
  totalUsers: 'Usuarios Totales',
  totalGroups: 'Grupos Totales',
  actionsSubmitted: 'Acciones Enviadas',
  actionsSubmittedFilter: 'Acciones enviadas durante los últimos {0}',
  allTimeStats: 'Estadísticas de Todos los Tiempos',
  totalActionsSubmitted: 'Número Total de Acciones Enviadas',
  actionsFirstAnswerCorrect:
    'Acciones con la Primera Respuesta Correcta en el Quiz',
  actionsFirstAnswerIncorrect:
    'Acciones con la Primera Respuesta Incorrecta en el Quiz',
  actionsSubmittedWithImage: 'Acciones Enviadas con Imagen',
  actionsSubmittedWithoutImage: 'Acciones Enviadas sin Imagen',
  numberActionsSubmittedWithImage: 'Número de Acciones Enviadas con Imagen',
  numberActionsSubmittedWithoutImage: 'Número de Acciones Enviadas sin Imagen',
  date: 'Fecha',
  gramsCO2Saved: 'Gramos de CO2 Ahorrados',
  applyFilter: 'Aplicar Filtro',
  createAction: 'Crear Acción',
  manageActions: 'Gestionar Acciones',
  manageQuizQuestions: 'Gestionar Preguntas de Quiz',
  sevenDays: '7 Días',
  thirtyDays: '30 Días',
  ninetyDays: '90 Días',
  oneYear: 'Año',
  co2SavedDuring: 'CO2 Ahorrado durante los últimos {0}',
  userNoteGroupOwner: ' (el dueño)',
  totalGramsSavedCO2PerDayAllActions:
    'Total de Gramos de CO2 Ahorrados por Día Para Todas las Acciones',
  continue: 'Continuar',
  done: 'Hecho',
  submit: 'Enviar',
  extraPoints: '¡Obtén Puntos Extra!',
  logActionButtonAddAnother: 'Agregar Otra',
  logActionButtonAllDone: 'Todo Listo',
  orSpace: 'o ',
  commit2ActHashtag: '#Commit2Act',
  logActionStepCompleted: 'Completado',
  logActionStepCurrent: 'Actual',
  logActionStepOfTotal: 'Paso {0} de {1}',
  logActionItemsErrorAlt: 'Error',
  logActionShareSummarySimple:
    '¡Te reto a igualar mi acción ahorrando +{0}g de CO2!',
  share: 'Copiar y Compartir',
  shareOnInstagram: 'Compartir en Instagram',
  shareOnTikTok: 'Compartir en TikTok',
  copyButtonCopy: 'Copiar',
  copyLink: 'copiar enlace',
  toShareManually: ' para compartir manualmente',
  copyButtonCopied: '¡Copiado!',
  logActionValidationLoading: 'Validando detalles de la acción',
  logActionValidationComplete: 'Validación completa',
  your: 'Tu',
  actionIsSubmitted: 'acción está siendo enviada',
  savingThePlanet: '¡Increíble, estás salvando el planeta!',
  checkAnswer: 'Verificar Respuesta',
  signup: {
    progressLabel: '{0} por ciento',
    stepLabel: 'Paso {0}',
    buttonBack: 'Atrás',
    buttonNext: 'Siguiente',
    buttonContinue: 'Continuar',
    buttonComplete: 'Completar',
    buttonConfirm: 'Confirmar',
    buttonSignup: 'Registrarse',
    buttonLetsGo: '¡Vamos!',
    buttonLetsTakeAction: '¡Tomemos Acción!',
    infoPrimaryHeadingOne: '¡Genial!',
    infoPrimarySubHeading: 'Comencemos',
    onboardStartHeading: 'Antes de empezar a actuar...',
    onboardStartSubHeading:
      'Queremos entender un poco mejor tu nivel de experiencia',
    infoSecondaryHeading: '¡Genial!',
    infoSecondarySubHeading: 'Comencemos',
    avatar: 'Avatar',
    avatarSelectAriaLabel: 'Etiqueta de selección de avatar',
    avatarSelectHeading: 'Elige tu avatar',
    avatarSelectSubHeading:
      '¡Elige qué criatura marina quieres usar en la app!',
    avatarReviewHeading: '¡Excelente elección!',
    avatarReviewSubHeading:
      'El {0} será tu compañero a lo largo de tu viaje',
    subjectExperiencedHeading: '¿Qué tan experimentado eres con la acción climática?',
    subjectFactHeading: '¡Fantástico! ¿Sabías que...',
    usageIntendHeading: '¿Cómo preferirías usar esta app?',
    usageInstructHeading: '¡Genial! Aquí tienes un vistazo interior:',
    usageInstructSubheading:
      'Commit2Act te permite rastrear el impacto de tus acciones diarias. Puedes competir con tus compañeros de clase, grupos escolares u otras escuelas para hacer el bien. ¡Puedes poner a prueba tus conocimientos con quizzes y aprovechar el reconocimiento de imágenes con IA para validar tus imágenes de impacto!',
    actionsSelectHeading: 'Actuemos ahora',
    actionsSelectSubheading:
      'Qué acciones serían más fáciles para ti de incorporar en tu rutina diaria:',
    actionsImpactHeading: '¡Increíble!',
    actionsImpactSubheading1a: 'Tus acciones podrían ahorrar hasta ',
    actionsImpactSubheading1b: ' de CO2 cada semana!',
    actionsImpactSubheading2:
      '¡Si actúas con tus amigos y comunidad, este impacto sería mucho, mucho mayor!',
    actionsImpactSubheading3:
      '¡Además puedes ganar aún más puntos extra agregando una acción cada día!',
    actionsIgnoreHeading: '¿Hay alguna acción que no puedas hacer?',
    actionsIgnoreSubheading:
      'Por ejemplo, si vives en una comunidad sin transporte público, o no tienes acceso a agua limpia, estas acciones pueden no ser posibles. No te pediremos que realices acciones que no puedas hacer.',
    onboardEndHeading: '¡Todo listo!!!',
    onboardEndSubheading: '¡No podemos esperar a ver el impacto que lograrás!',
    skipOnboardText: '¿Con prisa por empezar a actuar?',
    skipOnboardLink: 'Omitir por ahora',
    nickname: 'Apodo',
    enterYourNickname: 'Ingresa tu apodo',
    ageRange: 'Rango de Edad',
    country: 'País',
    province: 'Provincia',
    loadingText: 'Cargando',
    didNotReceiveConfirmation: '¿No recibiste un código de confirmación? ',
    contactCommit2Act: 'Contactar a Commit2Act',
    loadingConfirmation: 'Esto puede tomar hasta 30 segundos...',
  },
  textInput: {
    togglePasswordVisibility: 'Alternar Visibilidad de la Contraseña',
    requiredTextInput: 'Esto es requerido.',
    invalidEmail: 'Correo electrónico inválido.',
  },
  logActionPage: {
    noActionsAvailable: 'No hay acciones disponibles',
    loadingActions: 'Cargando acciones',
    noActionItemsAvailable: 'No hay elementos de acción disponibles',
    loadingActionItems: 'Cargando elementos de acción',
    imageUploadInstructions: 'Instrucciones de carga de imagen',
    actionValidation: 'Tu acción ha sido enviada para validación.',
    question: '¿Sabías que?',
    cO2Saved: 'de CO2 ahorrado!',
    pointsEarned: '¡Puntos Obtenidos!',
    takeTheBonusQuiz: '¡Haz el quiz extra para puntos adicionales!',
    savingThePlanet: '¡Increíble, estás salvando el planeta!',
    pointsEarnedForYourAction: 'Ganaste {0} puntos por tu acción.',
    greatJob: '¡Buen trabajo! Ganaste {0} puntos.',
    tryAgain: 'Puedes intentarlo de nuevo por {0} puntos. ¿Te gustaría intentarlo de nuevo?',
    dareYouToMatch: '¡Te reto a igualar mis {0} puntos actuando ahora!',
  },
  dashboardPage: {
    statProgress: 'Tu progreso estadístico',
    yourActions: 'Tus acciones',
    growYourKnowledge: 'Aumenta tu conocimiento y comprensión',
    leaderboard: 'La tabla de clasificación',
    yourImpact: 'Tu impacto',
    actionsThisWeek: 'Acciones esta semana',
    weeklyActions: '{0} Acciones',
    awaitingValidation: 'Esperando validación',
    actionsBreakdown: 'Desglose de mis acciones',
    actionsTaken: 'Acciones realizadas',
    weeklyCO2: 'CO2 semanal',
    totalCO2Saved: 'CO2 total ahorrado',
    currentStreak: 'Racha actual',
    actionsTakenColon: 'Acciones realizadas:',
    pointsEarnedColon: 'Puntos obtenidos:',
    totalPointsColon: 'Puntos totales:',
    logNow: 'Registrar ahora',
    emptyAction1: 'Has realizado ',
    emptyAction2: ' acciones. ¿Necesitas inspiración para ',
    emptyAction3: 'cómo realizar esta acción?',
    co2Saved: '{0} ahorrado',
    thisWeek: 'esta semana',
    fromLastWeek: 'desde la semana pasada',
  },
  userProfile: {
    title: "Perfil de {0}",
    resetPasswordButton: "Restablecer la contraseña de la cuenta",
    groupsTitle: "Grupos de {0}",
    actionsTitle: "Acciones de {0}",
    noGroupsMessage: "{0} no es miembro de ningún grupo",
    dialogTitle: "Restablecer la contraseña",
    successMessage: "Contraseña actualizada con éxito",
  },

};


export default translations;
